import { createSlice } from '@reduxjs/toolkit';
import * as _ from "lodash";
import { getTagLabel, getTicketLabel } from '../utils/queueUtils';
import { MQTT_MSG_TYPE } from '../constants/constants';

import { QUEUE_REQUEST_PARAMS } from '../constants/initialStates';

export const queueSlice = createSlice({
  name: 'queue',
  initialState: {
    queueConfig: undefined,
    requestParams: QUEUE_REQUEST_PARAMS,
    requestTicketSuccessfully: false,
    siteId: '',
    tagSequenceList: [],
    counterTagList: [],
    latestTag: ''
  },
  reducers: {
    setQueueConfig(state, action) {
      state.queueConfig = action.payload;
    },
    setRequestParams(state, action) {
      state.requestParams = action.payload;
    },
    setRequestTicketSuccessfully(state, action) {
      state.requestTicketSuccessfully = action.payload;
    },
    setTagSequenceList(state, action) {
      const newSiteId = action.payload.siteId;
      const newTagSequenceList = action.payload.tagSequenceList;
      if (!newTagSequenceList || newTagSequenceList.length === 0) {
        state.tagSequenceList = [];
      } else {
        let tempTagSequenceList = [];
        if (newSiteId !== state.siteId) {
          tempTagSequenceList = newTagSequenceList.map((tagSequence) => {
            return {
              timeSectionId: tagSequence.timeSectionId,
              showTableType: tagSequence.showTableType,
              tableType: tagSequence.tableType,
              tableTypeLabel: tagSequence.tableTypeLabel,
              tagStart: tagSequence.start,
              tagEnd: tagSequence.end,
              tagLabel: getTagLabel((tagSequence.showTableType) ? tagSequence.tableType : '', tagSequence.start, tagSequence.end),
              updateTimestamp: Number(tagSequence.updateTimestamp),
              ticketSequence: tagSequence.ticketSequence,
              ticketLabel: getTicketLabel((tagSequence.showTableType) ? tagSequence.tableType : '', tagSequence.ticketSequence),
              ticketUpdateTimestamp: Number(tagSequence.ticketUpdateTimestamp),
              quota: tagSequence.quota,
              mobileQueueAvailable: tagSequence.mobileQueueAvailable,
              rollTagType: tagSequence.type
            };
          });
        } else {
          tempTagSequenceList = _.cloneDeep(state.tagSequenceList);
          if (tempTagSequenceList) {
            tempTagSequenceList = tempTagSequenceList.filter((tempTag) => {
              return (newTagSequenceList.findIndex((a) => {
                return a.tableType === tempTag.tableType;
              }) !== -1)
            });
            newTagSequenceList.forEach((tagSequence) => {
              const tempTagSequence = tempTagSequenceList.find((tempTagSequence) => { return tempTagSequence.tableType === tagSequence.tableType });
              const updateTimestamp = Number(tagSequence.updateTimestamp);
              const ticketUpdateTimestamp = Number(tagSequence.ticketUpdateTimestamp);
              if (tempTagSequence) {
                if (tempTagSequence.updateTimestamp <= updateTimestamp) {
                  tempTagSequence.showTableType = tagSequence.showTableType;
                  tempTagSequence.tableTypeLabel = tagSequence.tableTypeLabel;
                  tempTagSequence.tagStart = tagSequence.start;
                  tempTagSequence.tagEnd = tagSequence.end;
                  tempTagSequence.tagLabel = getTagLabel((tagSequence.showTableType) ? tagSequence.tableType : '', tagSequence.start, tagSequence.end);
                  tempTagSequence.updateTimestamp = updateTimestamp;
                  tempTagSequence.rollTagType = tagSequence.type;
                }
                if (tempTagSequence.ticketUpdateTimestamp <= ticketUpdateTimestamp) {
                  tempTagSequence.ticketSequence = tagSequence.ticketSequence;
                  tempTagSequence.ticketLabel = getTicketLabel((tagSequence.showTableType) ? tagSequence.tableType : '', tagSequence.ticketSequence);
                  tempTagSequence.ticketUpdateTimestamp = ticketUpdateTimestamp;
                }
              } else if (!tempTagSequence) {
                tempTagSequenceList.push({
                  timeSectionId: tagSequence.timeSectionId,
                  showTableType: tagSequence.showTableType,
                  tableType: tagSequence.tableType,
                  tableTypeLabel: tagSequence.tableTypeLabel,
                  tagStart: tagSequence.start,
                  tagEnd: tagSequence.end,
                  tagLabel: getTagLabel((tagSequence.showTableType) ? tagSequence.tableType : '', tagSequence.start, tagSequence.end),
                  updateTimestamp: updateTimestamp,
                  ticketSequence: tagSequence.ticketSequence,
                  ticketLabel: getTicketLabel((tagSequence.showTableType) ? tagSequence.tableType : '', tagSequence.ticketSequence),
                  ticketUpdateTimestamp: ticketUpdateTimestamp,
                  quota: tagSequence.quota,
                  mobileQueueAvailable: tagSequence.mobileQueueAvailable,
                  rollTagType: tagSequence.type
                })
              }
            });
          }
        }
        state.siteId = newSiteId;
        state.tagSequenceList = tempTagSequenceList;
      }
    },
    setCounterTagList(state, action) {
      // const newSiteId = action.payload.siteId;
      const newCounterTagList = action.payload.counterTagList;
      if (!newCounterTagList || newCounterTagList.length === 0) {
        state.counterTagList = [];
      } else {
        const tempCounterTagList = newCounterTagList.map((counterTag) => {
          return {
            tableType: counterTag.tableType,
            tagLabel: getTagLabel(counterTag.tableType, counterTag.tagNumber, counterTag.tagNumber),
            counterName: counterTag.counterName,
            updateTimestamp: Number(counterTag.updateTimestamp)
          }
        });

        // state.siteId = newSiteId;
        state.counterTagList = tempCounterTagList;
      }
    },
    setTagSequenceListByMqtt(state, action) {
      // TAG_BATCH,A,1,1,1644204765422
      // TAG,A001,1657097054408
      // const topicContents = action.payload.topicContents;
      // console.log('topicContents', topicContents);
      const messageContents = action.payload.messageContents;
      let mqttUpdateTimestamp = undefined;
      let tableType = undefined;
      let tagStart = 0;
      let tagEnd = 0;
      switch (messageContents[0]) {
        case MQTT_MSG_TYPE.TAG:
          mqttUpdateTimestamp = Number(messageContents[2]);
          tableType = messageContents[1].substring(0, 1);
          const tagNumber = Number(messageContents[1].substring(1));
          tagStart = isNaN(tagNumber) ? 0 : tagNumber;
          tagEnd = isNaN(tagNumber) ? 0 : tagNumber;
          break;
        case MQTT_MSG_TYPE.TAG_BATCH:
          mqttUpdateTimestamp = Number(messageContents[4]);
          tableType = messageContents[1];
          tagStart = Number(messageContents[2]);
          tagEnd = Number(messageContents[3]);
          break;
        default:
      }

      if (!isNaN(mqttUpdateTimestamp)) {
        // const timeSectionId = topicContents[2];
        // console.log('tagSequenceList', tagSequenceList);
        const tempTagSequenceList = _.cloneDeep(state.tagSequenceList);
        // console.log('tempTagSequenceList ori', tempTagSequenceList);
        const tempTagSequence = tempTagSequenceList.find((tagSequence) => { return tagSequence.tableType === tableType });
        if (tempTagSequence) {
          if (tempTagSequence.updateTimestamp <= mqttUpdateTimestamp) {
            tempTagSequence.tagStart = tagStart;
            tempTagSequence.tagEnd = tagEnd;
            tempTagSequence.tagLabel = getTagLabel((tempTagSequence.showTableType) ? tableType : '', tagStart, tagEnd);
            tempTagSequence.updateTimestamp = mqttUpdateTimestamp;
          }
        } else {
          tempTagSequenceList.push({
            tableType: tableType,
            tagStart: tagStart,
            tagEnd: tagEnd,
            tagLabel: getTagLabel(tableType, tagStart, tagEnd),
            updateTimestamp: mqttUpdateTimestamp
          })
        }
        // console.log(tempTagSequenceList);
        state.tagSequenceList = tempTagSequenceList;
      }
    },
    setTicketSequenceListByMqtt(state, action) {
      //TIC,$B009,1644574483464
      const topicContents = action.payload.topicContents;
      // console.log(topicContents);
      if (state.siteId === topicContents[1]) {
        const messageContents = action.payload.messageContents;
        const mqttUpdateTimestamp = Number(messageContents[2]);
        if (!isNaN(mqttUpdateTimestamp)) {
          // console.log('topicContents', topicContents);
          // const timeSectionId = topicContents[2];
          const tableType = messageContents[1].substring(1, 2);
          const mqttTicketNumber = Number(messageContents[1].substring(2));
          const ticketNumber = (isNaN(mqttTicketNumber) || mqttTicketNumber <= 0) ? 0 : mqttTicketNumber - 1;
          // console.log('tableType', tableType);
          // console.log('ticketNumber', ticketNumber);
          // console.log('tagSequenceList', tagSequenceList);
          const tempTagSequenceList = _.cloneDeep(state.tagSequenceList);
          // console.log('tempTagSequenceList ori', tempTagSequenceList);
          const tempTagSequence = tempTagSequenceList.find((tagSequence) => { return tagSequence.tableType === tableType });
          if (tempTagSequence) {
            if (tempTagSequence.ticketUpdateTimestamp <= mqttUpdateTimestamp) {
              tempTagSequence.ticketSequence = ticketNumber;
              tempTagSequence.ticketLabel = getTicketLabel((tempTagSequence.showTableType) ? tempTagSequence.tableType : '', ticketNumber);
              tempTagSequence.ticketUpdateTimestamp = mqttUpdateTimestamp;
            }
          }
          // console.log(tempTagSequenceList);
          state.tagSequenceList = tempTagSequenceList;
        }
      }
    },
    setCounterTagListByMqtt(state, action) {
      // TAG,A003,1653450775241,{"counter":"0"}
      // SPEAK,A006,1,1654070485022
      // const topicContents = action.payload.topicContents;
      // console.log('topicContents', topicContents);
      const messageContents = action.payload.messageContents;
      let tagLabel = messageContents[1];
      let mqttUpdateTimestamp = Number(messageContents[2]);
      let counterName = undefined;
      switch (messageContents[0]) {
        case MQTT_MSG_TYPE.TAG:
          mqttUpdateTimestamp = Number(messageContents[2]);
          try {
            if (messageContents[3]) {
              counterName = '' + JSON.parse(messageContents[3]).counter;
            }
          } catch (e) {
            console.log('mqtt msg missing counter name');
          }
          break;
        case MQTT_MSG_TYPE.SPEAK:
          mqttUpdateTimestamp = Number(messageContents[3]);
          try {
            counterName = '' + messageContents[2];
          } catch (e) {
            console.log('mqtt msg missing counter name');
          }
          break;
        default:
      }
      if (!isNaN(mqttUpdateTimestamp)) {
        const tempCounterTagList = _.cloneDeep(state.counterTagList);
        // console.log('tempCounterTagList ori', tempCounterTagList);
        const tempCounterTag = tempCounterTagList.find((counterTag) => { return counterTag.tagLabel === tagLabel });
        if (tempCounterTag) {
          if (tempCounterTag.updateTimestamp <= mqttUpdateTimestamp) {
            tempCounterTag.counterName = counterName;
            tempCounterTag.updateTimestamp = mqttUpdateTimestamp;
          }
        } else {
          tempCounterTagList.push({
            tableType: tagLabel.substring(0, 1),
            tagLabel: tagLabel,
            counterName: counterName,
            updateTimestamp: mqttUpdateTimestamp
          })
        }
        // console.log(tempCounterTagList);
        state.counterTagList = tempCounterTagList.sort((a, b) => { return b.updateTimestamp - a.updateTimestamp; }).slice(0, 6);
      }
    },
    resetQueue(state, action) {
      state.queueConfig = action.payload.queueConfig;
      state.requestParams = action.payload.requestParams;
    },
    setLatestTag(state, action) {
      state.latestTag = action.payload;
    }
  }
})

export const { setQueueConfig, setRequestParams, setRequestTicketSuccessfully, setTagSequenceList, setCounterTagList, setTagSequenceListByMqtt, setTicketSequenceListByMqtt, setCounterTagListByMqtt, resetQueue, setLatestTag } = queueSlice.actions

export default queueSlice.reducer